import axios from 'axios'
import { accessToken, client, guestClient, userClient } from './auth'
import { AddAddressType, AddressList, AddressItem } from '../../src/@types/order'

interface returnType {
  claimType: string
  claimReasonType: string
  claimReasonDetail: string
  receiverName: string
  receiverZipCd: string
  receiverAddress: string
  receiverJibunAddress: string
  receiverDetailAddress: string
  receiverContact1: string
  customsIdNumber: string
  countryCd: string
  deliveryMemo: string
  receiverFirstName: null | string
  receiverLastName: null | string
  returnWayType: null | string
  orderProductOptionNo: number
  productCnt: number
}

/** 주문 리스트 조회하기 */
export async function getOrderList() {
  return await userClient.get(`/profile/orders?pageSize=100&hasTotalCount=true`)
}

export async function getOrderListHeader(accessToken: string) {
  return await client.get(`/profile/orders?pageSize=100&hasTotalCount=true`, { headers: { accessToken: accessToken } })
}

/** 주문 리스트 상세 조회 */
export async function getOrderDetail(orderNo: number) {
  return await userClient.get(`/profile/orders/${orderNo}`)
}

/** 주문 리스트 상세 조회 */
export async function getOrderRefundDetail(orderNo: number) {
  return await userClient.get(`/profile/orders/${orderNo}?orderRequestType=NORMAL`)
}

//취소 클레임 안걸린거 조회
export async function getOrderCancelDetail(orderNo: bigint) {
  return await userClient.get(`/profile/orders/${orderNo}?orderRequestType=NORMAL`)
}

//취소 클레임 안걸린거 조회
export async function getGuestOrderCancelDetail(orderNo: bigint, guestToken: string) {
  return await client.get(`/guest/orders/${orderNo}?orderRequestType=NORMAL`, {
    headers: {
      guestToken,
    },
  })
}

/** 비회원 리스트 상세 조회 */
export async function getGuestOrderDetail(orderNo: number, guestToken: string) {
  return await client.get(`/guest/orders/${orderNo}`, {
    headers: {
      guestToken,
    },
  })
}

/** 비회원 리스트 상세 조회 */
export async function getGuestOrderRefundDetail(orderNo: number, guestToken: string) {
  return await client.get(`/guest/orders/${orderNo}?orderRequestType='NORMAL'`, {
    headers: {
      guestToken,
    },
  })
}

/** 주문 취소(비회원) */
export async function postGuestCancel(
  orderNo: string,
  claimType: string,
  claimReasonType: string,
  claimReasonDetail: string,
  guestToken: string
) {
  return await guestClient.post(
    `/guest/orders/${orderNo}/claims/cancel`,
    {
      claimType: claimType,
      claimReasonType: claimReasonType,
      claimReasonDetail: claimReasonDetail,
      bankAccountInfo: null,
      saveBankAccountInfo: false,
      responsibleObjectType: null,
      refundsImmediately: true,
    },
    {
      headers: {
        guestToken,
      },
    }
  )
}

/** 주문 취소(회원) */
export async function postUserCancel(
  orderNo: string,
  claimType: string,
  claimReasonType: string,
  claimReasonDetail: string
) {
  return await userClient.post(`/profile/orders/${orderNo}/claims/cancel`, {
    claimType: claimType,
    claimReasonType: claimReasonType,
    claimReasonDetail: claimReasonDetail,
    bankAccountInfo: null,
    saveBankAccountInfo: false,
    responsibleObjectType: null,
    refundsImmediately: true,
  })
}

/** 주문  취소 복수*/
export async function postOptionsCancel(
  product: string,
  claimType: string,
  claimReasonType: string,
  claimReasonDetail: string
) {
  return await userClient.post(`/profile/claims/cancel`, {
    claimType: claimType,
    claimReasonType: claimReasonType,
    claimReasonDetail: claimReasonDetail,
    bankAccountInfo: null,
    saveBankAccountInfo: false,
    responsibleObjectType: null,
    claimedProductOptions: product,
    refundsImmediately: true,
  })
}

/** 주문옵션 취소 */
export async function postOptionCancel(
  optionNumber: string,
  claimType: string,
  claimReasonType: string,
  claimReasonDetail: string
) {
  return await userClient.post(`/profile/order-options/${optionNumber}/claims/cancel`, {
    claimType: claimType,
    claimReasonType: claimReasonType,
    claimReasonDetail: claimReasonDetail,
    bankAccountInfo: null,
    saveBankAccountInfo: false,
    responsibleObjectType: null,
    refundsImmediately: true,
    productCnt: 1,
  })
}

export async function postGuestOptionCancel(
  product: string,
  claimType: string,
  claimReasonType: string,
  claimReasonDetail: string,
  guestToken: string
) {
  return await userClient.post(
    `/guest/claims/cancel`,
    {
      claimType: claimType,
      claimReasonType: claimReasonType,
      claimReasonDetail: claimReasonDetail,
      bankAccountInfo: null,
      saveBankAccountInfo: false,
      responsibleObjectType: null,
      claimedProductOptions: product,
      refundsImmediately: true,
    },
    { headers: { guestToken } }
  )
}

/** 비회원 패스워드 초기화 */
export async function getGuestResetpw(orderNo: string, phoneNo: string, name: string) {
  return await client.get(`/guest/orders/${orderNo}/forgot-password?replyType=SMS&mobileNo=${phoneNo}&name=${name}`)
}

/** 비회원 토큰 발급하기 */
export async function postGuestToken(orderNo: string, password: string) {
  return await client.post(`/guest/orders/${orderNo}`, {
    orderRequestType: 'ALL',
    password: password,
    name: null,
    mobileNo: null,
    email: null,
  })
}

/** 상품평 작성 가능한 목록 */
export async function getReviewable() {
  return await userClient.get(`/profile/order-options/product-reviewable?hasTotalCount=true`)
}

/** 이미지 업로드 */
export async function postPicture(formData: any) {
  return await client.post(`/files/images`, formData)
}

/** 주소록 조회 */
export async function getBookedAddresses(pageNumber = 1, pageSize = 40) {
  return await userClient.get(`/profile/shipping-addresses/booked?page=${pageNumber}&size=${pageSize}`)
}

/** 최근 배송지 가져오기 */
export async function getRecentAddress() {
  return await userClient.get(`/profile/shipping-addresses/recent`)
}

/** 배송지 리스트 가져오기 */
export async function getAddressList(): Promise<AddressList> {
  const response = await userClient.get<AddressList>(`/profile/shipping-addresses`)
  return response.data
}

/** 배송지 추가 */
export async function postAddress(addressInfo: AddAddressType) {
  const {
    defaultYn, // 기본 배송지 여부
    addressName, // 주소록명
    receiverName, // 수령자 명
    receiverContact1, // 연락처1
    receiverZipCd, // 배송지 우편 번호
    receiverAddress, // 배송지 주소
    receiverDetailAddress, // 배송지 상세 주소
    receiverJibunAddress,
    addressMemo, // 주소 메모
  } = addressInfo
  return await userClient.post(`/profile/shipping-addresses`, {
    defaultYn,
    addressName,
    receiverName,
    receiverContact1,
    receiverZipCd,
    receiverAddress,
    receiverDetailAddress,
    receiverJibunAddress,
    addressMemo: addressMemo || null,
    addressType: 'BOOK', // 주소 타입 BOOK: 기본주소, RECENT: 최근주소, RECURRING_PAYMENT: 정기결제 배송주소, RECURRING_PAYMENT_PRESENT: 정기결제 선물하기 배송주소
  })
}

export async function updateAddress(addressInfo: AddressItem, addressNo: number) {
  await putAddress(addressInfo)
  if (addressInfo.defaultYn === 'Y') await setDefaultAddress(addressNo)
}

export async function putAddress(addressInfo: AddressItem) {
  const {
    defaultYn, // 기본 배송지 여부
    addressName, // 주소록명
    receiverName, // 수령자 명
    receiverContact1, // 연락처1
    receiverZipCd, // 배송지 우편 번호
    receiverAddress, // 배송지 주소
    receiverDetailAddress, // 배송지 상세 주소
    addressMemo, // 주소 메모
    addressNo, // 주소 ID
  } = addressInfo
  return await userClient.put(`/profile/shipping-addresses/${addressNo}`, {
    defaultYn, // 기본 배송지 여부
    addressName, // 주소록명
    receiverName, // 수령자 명
    receiverContact1, // 연락처1
    receiverZipCd, // 배송지 우편 번호
    receiverAddress, // 배송지 주소
    receiverDetailAddress, // 배송지 상세 주소
    addressMemo, // 주소 메모
    addressType: 'BOOK', // 주소 타입 BOOK: 기본주소, RECENT: 최근주소, RECURRING_PAYMENT: 정기결제 배송주소, RECURRING_PAYMENT_PRESENT: 정기결제 선물하기 배송주소
  })
}

export async function setDefaultAddress(addressNo: number) {
  return await userClient.put(`/profile/shipping-addresses/${addressNo}/default`)
}

export async function deleteAddress(addressNo: number) {
  return await userClient.delete(`/profile/shipping-addresses/${addressNo}`)
}

/** 배송지 배송비 적용 */
export async function postAddressCalculate(
  orderSheetNo: string,
  zipCode: string,
  address: string,
  detailAddress: string,
  jibun: string,
  selectCoupon: any
) {
  if (accessToken) {
    return await userClient.post(`/order-sheets/${orderSheetNo}/calculate`, {
      accumulationUseAmt: null,
      addressRequest: {
        addressName: null,
        receiverZipCd: zipCode,
        receiverAddress: address,
        receiverDetailAddress: detailAddress,
        receiverJibunAddress: jibun,
        receiverCity: null,
        receiverState: null,
        receiverName: null,
        receiverContact1: null,
        receiverContact2: null,
        customsIdNumber: null,
        countryCd: 'KR',
        addressType: 'RECENT',
        defaultYn: 'false',
      },
      couponRequest: selectCoupon,
      shippingAddresses: null,
    })
  } else {
    return await client.post(`/order-sheets/${orderSheetNo}/calculate`, {
      accumulationUseAmt: 100,
      addressRequest: {
        addressName: null,
        receiverZipCd: zipCode,
        receiverAddress: address,
        receiverDetailAddress: detailAddress,
        receiverJibunAddress: jibun,
        receiverCity: null,
        receiverState: null,
        receiverName: null,
        receiverContact1: null,
        receiverContact2: null,
        customsIdNumber: null,
        countryCd: 'KR',
        addressType: 'RECURRING_PAYMENT',
        defaultYn: 'false',
      },
      couponRequest: null,
      shippingAddresses: null,
    })
  }
}

/** 배송지 배송비 적용 */
export async function postUserAddressCalculate(
  orderSheetNo: string,
  receiverZipCd: string,
  receiverAddress: string,
  receiverDetailAddress: string,
  receiverJibunAddress: string,
  selectCoupon: any,
  accumulationUseAmt?: number
) {
  return await userClient.post(`/order-sheets/${orderSheetNo}/calculate`, {
    accumulationUseAmt: accumulationUseAmt || null,
    addressRequest: {
      addressName: null,
      receiverZipCd: receiverZipCd,
      receiverAddress: receiverAddress,
      receiverDetailAddress: receiverDetailAddress,
      receiverJibunAddress: receiverJibunAddress,
      receiverCity: null,
      receiverState: null,
      receiverName: null,
      receiverContact1: null,
      receiverContact2: null,
      customsIdNumber: null,
      countryCd: 'KR',
      addressType: 'RECENT',
      defaultYn: 'false',
    },
    couponRequest: selectCoupon,
    shippingAddresses: null,
  })
}

export async function postGuestAddressCalculate(
  orderSheetNo: string,
  zipCode: string,
  address: string,
  detailAddress: string,
  jibun: string
) {
  return await client.post(`/order-sheets/${orderSheetNo}/calculate`, {
    accumulationUseAmt: null,
    addressRequest: {
      addressName: null,
      receiverZipCd: zipCode,
      receiverAddress: address,
      receiverDetailAddress: detailAddress,
      receiverJibunAddress: jibun,
      receiverCity: null,
      receiverState: null,
      receiverName: null,
      receiverContact1: null,
      receiverContact2: null,
      customsIdNumber: null,
      countryCd: 'KR',
      addressType: 'RECURRING_PAYMENT',
      defaultYn: 'false',
    },
    couponRequest: null,
    shippingAddresses: null,
  })
}

/** 주문 배송지 변경 
 *  orderNo: number,
  receiverZipCd: string,
  receiverAddress: string,
  receiverJibunAddress: string,
  receiverDetailAddress: string,
  receiverName: string,
  receiverContact1: string,
  deliveryMemo: string
 * 
*/
export async function putDeliveries(
  orderNo: string,
  receiverZipCd: string,
  receiverAddress: string,
  receiverJibunAddress: string,
  receiverDetailAddress: string,
  receiverName: string,
  receiverContact1: string,

  deliveryMemo: string
) {
  if (accessToken) {
    return await userClient.put(`/profile/orders/${orderNo}/deliveries?add=true`, {
      receiverZipCd: receiverZipCd,
      receiverAddress: receiverAddress,
      receiverJibunAddress: receiverJibunAddress,
      receiverDetailAddress: receiverDetailAddress,
      receiverCity: null,
      receiverState: null,
      receiverName: receiverName,
      receiverContact1: receiverContact1,
      receiverContact2: null,
      customsIdNumber: null,
      countryCd: null,
      deliveryMemo: deliveryMemo,
      receiverFirstName: null,
      receiverLastName: null,
    })
  } else {
    return await client.put(`/profile/orders/${orderNo}/deliveries?add=true`, {
      receiverZipCd: receiverZipCd,
      receiverAddress: receiverAddress,
      receiverJibunAddress: receiverJibunAddress,
      receiverDetailAddress: receiverDetailAddress,
      receiverCity: null,
      receiverState: null,
      receiverName: receiverName,
      receiverContact1: receiverContact1,
      receiverContact2: null,
      customsIdNumber: null,
      countryCd: null,
      deliveryMemo: deliveryMemo,
      receiverFirstName: null,
      receiverLastName: null,
    })
  }
}

/** 환불 하기
 * claimReasonType: string,
  claimReasonDetail: string,
  receiverName: string,
  receiverZipCd: string,
  receiverAddress: string,
  receiverJibunAddress: string,
  receiverDetailAddress: string,
  receiverContact1: string,
 * 
 * 
 * 
 *  (회원) */
export async function postUserReturn(
  claimReasonType: string,
  claimReasonDetail: string,
  receiverName: string,
  receiverZipCd: string,
  receiverAddress: string,
  receiverJibunAddress: string,
  receiverDetailAddress: string,
  receiverContact1: string,
  option: any
) {
  return await userClient.post(`/profile/claims/return`, {
    claimImageUrls: null,
    claimType: 'RETURN',
    claimReasonType: claimReasonType,
    claimReasonDetail: claimReasonDetail,
    bankAccountInfo: null,
    saveBankAccountInfo: false,
    returnAddress: {
      receiverName: receiverName,
      receiverZipCd: receiverZipCd,
      receiverAddress: receiverAddress,
      receiverJibunAddress: receiverJibunAddress,
      receiverDetailAddress: receiverDetailAddress,
      receiverCity: null,
      receiverState: null,
      receiverContact1: receiverContact1,
      receiverContact2: null,
      customsIdNumber: null,
      countryCd: null,
      deliveryMemo: null,
      receiverFirstName: null,
      receiverLastName: null,
    },
    returnWayType: null,
    claimedProductOptions: option,
    deliveryCompanyType: null,
    invoiceNo: null,
    responsibleObjectType: null,
  })
}

/** 주문예약 */
export async function postReserve(option: any) {
  return await userClient.post(`/payments/reserve`, option)
}
export async function postAppReserve(option: any, accessToken: string) {
  return await userClient.post(`/payments/reserve`, option, {
    headers: { accessToken },
  })
}
/**  비회원 반품*/
export async function postGuestReturn(
  claimReasonType: string,
  claimReasonDetail: string,
  receiverName: string,
  receiverZipCd: string,
  receiverAddress: string,
  receiverJibunAddress: string,
  receiverDetailAddress: string,
  receiverContact1: string,
  option: any,
  guestToken: string
) {
  return await client.post(
    `/guest/claims/return`,
    {
      claimImageUrls: null,
      claimType: 'RETURN',
      claimReasonType: claimReasonType,
      claimReasonDetail: claimReasonDetail,
      bankAccountInfo: null,
      saveBankAccountInfo: false,
      returnAddress: {
        receiverName: receiverName,
        receiverZipCd: receiverZipCd,
        receiverAddress: receiverAddress,
        receiverJibunAddress: receiverJibunAddress,
        receiverDetailAddress: receiverDetailAddress,
        receiverCity: null,
        receiverState: null,
        receiverContact1: receiverContact1,
        receiverContact2: null,
        customsIdNumber: null,
        countryCd: null,
        deliveryMemo: null,
        receiverFirstName: null,
        receiverLastName: null,
      },
      returnWayType: null,
      claimedProductOptions: option,
      deliveryCompanyType: null,
      invoiceNo: null,
      responsibleObjectType: null,
    },
    { headers: { guestToken } }
  )
}
/** 상품 구매 확정 */
export async function putUserConfirm(orderOptionNo: number) {
  return await userClient.put(`/profile/order-options/${orderOptionNo}/confirm`)
}

export async function putGuestConfirm(orderOptionNo: number, guestToken: string) {
  return await client.put(
    `/guest/order-options/${orderOptionNo}/confirm`,
    {},
    {
      headers: { guestToken: guestToken },
    }
  )
}

/** 마이페이 조회 */
export async function getPayInfo() {
  return await userClient.get(`/my-pay/payment-infos`)
}

/** 마이페이 회원등록위한 webUrl */
export async function getRegisterUser() {
  return await userClient.get(`/my-pay/register-user?clientReturnUrl=${process.env.REACT_APP_SHOP_URL}/addcard`)
}

/** 마이페이 회원등록후 결제수단 */
export async function getRegisterUserWithPayment() {
  return await userClient.get(
    `/my-pay/register-user-with-payment?clientReturnUrl=${process.env.REACT_APP_SHOP_URL}/bridge&clientBridgeUrl=${process.env.REACT_APP_SHOP_URL}/close`
  )
}

/** 마이페이 결제수단 등록 */
export async function getRegisterCard() {
  return await userClient.get(
    `/my-pay/register-payment?clientReturnUrl=${process.env.REACT_APP_SHOP_URL}/close&payMethod=01`
  )
}

/** 마이페이 등록된 결제 수단 삭제  */
export async function deletePayInfo(payToken: string) {
  return await userClient.delete(`/my-pay/payment-infos?payToken=${payToken}`)
}

/** 마이페이 회원 탈퇴 */
export async function deleteUserInfo() {
  return await userClient.delete(`/my-pay/user`)
}

/** 네이버페이 주문서 생성 */
export async function postNaverOrderSheet(item: any, app: boolean) {
  return await userClient.post(`/payments/naver/ordersheet`, {
    items: item,
    clientReturnUrl: `${process.env.REACT_APP_SHOP_URL}/naverclose?app=${app}`,

    naCo: null,
    nvadid: null,
    extraData: null,
  })
}

/** 상품평 가능 유무 조회 */
export async function getReviewableProduct(productNo: number) {
  return await userClient.get(`/products/${productNo}/reviewable-options`)
}

/** 외부 api */
export async function putPrepareProduct(item: any) {
  return await axios.put(`https://server-api.e-ncp.com/orders/prepare-product`, item, {
    headers: {
      Version: '1.0',
      systemkey: process.env.REACT_APP_SYSTEM_KEY,
      mallKey: process.env.REACT_APP_MALL_KEY,
    },
  })
}

/** 주소 조회하기 */
export async function getAddressSearch(address: string) {
  return await userClient.get(`/addresses/search?keyword=${address}`)
}

/** 클레임 정보조회 */
export async function getClaimsInfo(orderNo: string) {
  return await userClient.get(`/profile/order-options/${orderNo}/claims?claimType=CANCEL`)
}

/** 이전 주문 수량 조회 */
export async function getOrderSummary() {
  return await userClient.get(`/profile/previous-orders/summary?startYmd=2024-01-01`)
}
